import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import VerifierRegistration from '../../components/verifier/VerifierRegistration';
import VerifierDashboard from '../../components/verifier/VerifierDashboard';
import VerifierProfile from '../../components/verifier/VerifierProfile';
import VerificationProjects from '../../components/verifier/VerificationProjects';
import VerificationWorkspace from '../../components/verifier/VerificationWorkspace';
import VerifierMarketplace from '../../components/verifier/VerifierMarketplace';

const VerifierPortal = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route path="/" element={<Navigate to="/verifier/register" replace />} />
        <Route path="/register" element={<VerifierRegistration />} />
        <Route path="/dashboard" element={<VerifierDashboard />} />
        <Route path="/profile" element={<VerifierProfile />} />
        <Route path="/projects" element={<VerificationProjects />} />
        <Route path="/marketplace" element={<VerifierMarketplace />} />
        <Route path="/workspace/:projectId" element={<VerificationWorkspace />} />
        <Route path="*" element={<Navigate to="/verifier/register" replace />} />
      </Routes>
    </div>
  );
};

export default VerifierPortal; 